export const CUPOM_RECOMENDACAO_UPDATE = "CUPOM_RECOMENDACAO_UPDATE";
export const CUPOM_RECOMENDACAO_LOAD = "CUPOM_RECOMENDACAO_LOAD";
export const CUPOM_DESCONTO_CREATE = "CUPOM_DESCONTO_CREATE";
export const CUPOM_DESCONTO_REMOVE = "CUPOM_DESCONTO_REMOVE";
export const CUPOM_DESCONTO_LOAD = "CUPOM_DESCONTO_LOAD";
